import React from 'react'
import './style.css'
import renderHTML from 'react-render-html';

export default (props) => {
    return(
        <div className='imagens_content content_wrapper'>
            {renderHTML(props.conteudo)}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/views/website/imagens/component.js